import React from 'react';
import { DataTableStyles } from './Table.styles';
import { DataTableProps } from './Table.types';
import TableContainer from './TableContainer';

export default function DataTableWrap({ onAddRow, ...props }: DataTableProps) {  
  return (
    <DataTableStyles>
      <TableContainer
        {...props}
        onAddRow={onAddRow}
      />
    </DataTableStyles>
  )
}